import React from 'react';
import PropTypes from 'prop-types';

export default function ConfirmationModal({ 
  show, 
  title, 
  message, 
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  confirmButtonStyle = 'danger', // 'danger' | 'primary'
  onConfirm,
  onCancel 
}) {
  if (!show) return null;

  const getConfirmButtonClasses = () => {
    if (confirmButtonStyle === 'danger') {
      return 'bg-red-500 hover:bg-red-600 text-white';
    }
    return 'bg-primary hover:bg-primaryDark text-white';
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50 p-4">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg space-y-4">
        {/* Title */}
        <h3 className="text-xl font-bold text-textDark">
          {title}
        </h3>

        {/* Message */}
        <p className="text-textMed">
          {message}
        </p>

        {/* Buttons */}
        <div className="flex justify-end space-x-3 pt-4">
          <button
            onClick={onCancel}
            className="px-4 py-2 border border-border text-textMed hover:bg-gray-50 rounded-lg"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            className={`px-4 py-2 rounded-lg ${getConfirmButtonClasses()}`}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmationModal.propTypes = {
  show: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  confirmButtonStyle: PropTypes.oneOf(['danger', 'primary']),
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}; 